import _ from 'lodash';
import template from './security-questions.html';

// eslint-disable-next-line no-undef
@Inject('Responsive')
class SecurityQuestionsController {
  constructor() {
    this.questionsWrapper = [
      {
        modelQuestion: 'questionA',
        modelAnswer: 'answerA',
        questions: [],
      },
      {
        modelQuestion: 'questionB',
        modelAnswer: 'answerB',
        questions: [],
      },
    ];
  }

  $onChanges() {
    this.questionsWrapper.forEach((value, index) => {
      this.questionsWrapper[index].questions = _.cloneDeep(this.securityQuestions || []);
    });
  }

  checkQuestions() {
    this.clearCheckQuestions();

    const arr = [];
    _.each(this.questionsWrapper, (questionItem) => {
      arr.push(this.formModel[questionItem.modelQuestion]);
    });

    if (_.uniq(arr).length === 1) {
      _.each(this.questionsWrapper, (questionItem) => {
        this.form[`securityQuestion-${questionItem.modelQuestion}`].$submitted = true;
        this.form[`securityQuestion-${questionItem.modelQuestion}`].$setValidity('same-question', false);
      });
    }
  }

  clearCheckQuestions() {
    _.each(this.questionsWrapper, (questionItem) => {
      this.form[`securityQuestion-${questionItem.modelQuestion}`].$setValidity('same-question', true);
    });
  }

  canShowOption(index, securityQuestion) {
    return this.formModel[this.questionsWrapper[(index + 1) % 2].modelQuestion] !== securityQuestion.code;
  }
}

export default class SecurityQuestionsComponent {
  constructor() {
    this.template = template;
    this.controller = SecurityQuestionsController;
    this.bindings = {
      form: '<',
      formModel: '=',
      securityQuestions: '<',
      securityQuestionsSize: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/security/components/security-questions/security-questions-component.js